import CreatableComponent from "../../ui/create/CreatableComponent";


export default class KeywordMultiSelector extends CreatableComponent<string> {
	elementToText(keyword: string) {
		return keyword;
	}
}
